<fs-nav class="nav-wrapper__nav"></fs-nav>

<fs-nav
  class="nav-wrapper__nav--mobile"
  *ngIf="isMobileNavOpen"
  [hasBack]="true"
  [@navToggle]
></fs-nav>
